@use 'styles/utils/mixins' as *;

.contentWrap {
  height: 100% !important;
  height: calc(100vh - 10rem) !important;
}

.content {
  text-align: center;

  // The numerals are black on transparent and vanish on the dark page; inverting keeps them as
  // light as the body text.
  :global([data-theme='dark']) & {
    filter: invert(0.9);
  }
}

.title {
  font-size: 2.8rem !important;
  line-height: 1.2 !important;
  @include mq(sm) {
    font-size: 1.8rem !important;
  }
}

.text {
  font-size: 1.8rem !important;
  @include mq(sm) {
    font-size: 1.5rem !important;
  }
}

.column {
  padding: 0 1.6rem;
  text-align: center;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
}
